import React from "react";
import SectionHeader from "../components/SectionHeader";

const AdvisorsSection = ({ data }) => (
    <section className="universitys" id="universitys">

        <div className="container">

            {/* =================================================
                 HEADER
            ================================================== */}

            <SectionHeader
                eyebrow={data.eyebrow}
                title={data.title}
                highlight={data.highlight}
                description={data.description}
            />


            {/* =================================================
                 ADVISORS
            ================================================== */}

            <div className="university-grid">

                {(data.items || []).map((item, i) => (

                    <article
                        className="university-card"
                        key={item.id || i}
                    >

                        {item.logo && (
                            <div class="university-partner-logo">

                                <img
                                    src={item.logo}
                                    alt={item.alt || item.name}
                                />

                            </div>
                        )}

                        <div className="university-content">

                            <h3>
                                {item.name}
                            </h3>

                            {item.title && (
                                <p className="university-title">
                                    {item.title}
                                </p>
                            )}

                            {item.organization && (
                                <p className="university-organization">
                                    {item.organization}
                                </p>
                            )}

                            {item.country && (
                                <p className="university-country">
                                    {item.country}
                                </p>
                            )}

                            {item.description && (
                                <p className="university-bio">
                                    {item.description}
                                </p>
                            )}

                            {(item.website) && (
                                <div className="university-links">

                                    {item.website && (
                                        <a
                                            href={item.website}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Website
                                        </a>
                                    )}

                            

                                </div>
                            )}

                        </div>

                    </article>

                ))}

            </div>

        </div>

    </section>
);

export default AdvisorsSection;